const en = {
  message: {
    header: {
      aboutus: "Home",
      project: "the project",
      team: "the team",
      sponsors: "Sponsors",
      donate: "donate",
      "contact-us": "Find US",
      media: "media",
      pictures: "photos",
      movies: "Videos",
      model: "3D Model",
    },

    notifications: {
      join: "Join the team",
    },

    home: {
      presentation:
        "Formule ETS is a scientific club composed of several students from the École de technologie supérieure, who design and build an electric race car to win Formula SAE and Formula Student competitions.",
      aboutUs: {
        title: "Who are we ?",
        text: "Formule ETS is a team of students in various fields of engineering from Montreal's École de technologie supérieure. Our prototypes have been recognized as complex and avant-garde since 1988. In 2020, we took the electric turn, before turning our attention to autonomous driving in 2023. For several years, the team has distinguished itself in international engineering competitions, Formula SAE and Formula Student. <br/><br/> These competitions bring together more than 600 universities of 46 different nationalities, who compete in dynamic events on the track and static ones in front of judges. In recent years, our team has had the opportunity to travel to competitions in Canada, the United States and Europe.",
      },
      project: {
        title: "The project !",
        text: `For over 35 years, we've been building racing cars for the purpose of competing, always with the same goal in mind: to win every competition we enter. <br/><br/> The vehicles that leave our workshop are more and more developed every year, and we seek to push the limits of engineering ever further. <br/><br/> Our third electric car, the MANIC-23, weighs just 186 kg and has a statutory output of 80 kW or 108 hp. It is powered by 4 electric wheel-motors with custom suspension and a carbon-fiber chassis. This combination delivers 0-100 kph in 2.5 seconds, and lateral acceleration of up to 2.5G in corners. `,
      },
      team: {
        title: "The team!",
        text: `Formule ETS is a club made up of more than 30 members all passionate about design, engineering and mechanics. <br> <br> This is why within our team you will find an atmosphere of solidarity and mutual aid. If you want to help us do not hesitate to come and see us in our offices. <br> <br> To learn more about our team go to the "Team" section .`,
      },
    },

    date: {
      mainTitle: "Important dates",
      title: {
        FSEAST: "Formula Student EAST",
        FSG: "Formula Student Germany",
        FSAA: "Formula Student Alpe Adria",

      },
      informations: "More informations",
      months: "Months",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      time: "{0} Days {1} Hours {2} Minutes {3} Seconds",
    },

    other: {
      back: "Go back",
    },

    eastereggs: {
      phone: "You found an easter egg. But we need a keyboard to be working :/",
    },

    404: {
      title: "Page not found",
    },

    albums: {
      title: "Albums",
      title_aside: "Years",
      year: "Year",
    },

    team: {
      title: "The team",
      teams: "Teams",
      year: "Year",
      management: "Management",
      aerodynamic: "Aerodynamics",
      chassis: "Chassis",
      dynamics: "Vehicle Dynamics",
      electronics: "Electronics",
      control: "Control",
      power_n_drive: "Power & Drive",
      powertrain: "Powertrain",
      drivetrain: "Drivetrain",
      machining: "Machining",
      sponsors_n_media: "Sponsors & Media",
      external_relationship: "External Relationship & Logistics",
      logistics: "Logistics",
      driverless: "Software and Autonomous System",
      statics: "Statics",
      roles: {
        captain: "Team captain",
        "co-captaine": "Team co-captain",
        "technical-director": "Technical director",
        "co-technical-director": "Co-Technical director",
        "management-director": "Management director",
        "head-aerodynamics": "Head of Aerodynamics",
        "lead-aerodynamics": "Aerodynamics Lead",
        "head-chassis": "Head of Chassis",
        "lead-chassis": "Chassis Lead",
        "heade-dynamic": "Head of Dynamics",
        "lead-dynamic": "Dynamics Lead",
        "lead-control": "Control Lead",
        "head-electronic": "Head of Electronics",
        "lead-electronic": "Electronics Lead",
        "head-media-sponsors": "Head of Sponsors & Media",
        "lead-external-relationship": "External Relationship & Logistics Lead",
        "head-power-drive": "Head of Power & Drive",
        "lead-powertrain": "Powertrain Lead",
        "lead-drivetrain": "Drivetrain Lead",
        "lead-machining": "Machining Lead",
        "head-power-drive-elec": "Head of Power & Drive Electrical",
        "head-power-drive-meca": "Head of Power & Drive Mechanical",
        "lead-logistics": "Logistics Lead",
        "lead-driverless": "Software & Autonomous System Lead",
        "lead-driverless-mec": "Driverless Mechanical Lead",
        "lead-statics": "Statics Lead",
        "treasurer": "Treasurer",
        "lead-business": "Business Lead",
        "lead-cost": "Cost Lead",
      },
    },

    videos: {
      title: "Videos",
    },

    sponsors: {
      button: "Become a partner",
      title: "Formule ETS powered by",
      diamond: "Diamond",
      gold: "Gold",
      silver: "Silver",
      bronze: "Bronze",
      classic: "Classic"
    },

    project: {
      auto: "Automatic",
      stop: "Stop",
      default: {
        animation: "dynamic animation",
        label:
          "Scroll down to start the animation and see our prototype in 3D.",
      },
      text: {
        chassis: {
          title: "Chassis",
          label:
            "Entirely designed and manufactured by Formule ETS. <br> The carbon fiber monocoque offers an optimal combination of safety for the driver. <br> Its honeycomb structure guarantees minimal weight for maximum performance.",
        },
        drivetrain: {
          title: "Drivetrain",
          label:
            "Planetary gear transmission. <br> Fastened to custom-designed 3D printed aluminum uprights, machined on an in-house 5-axis CNC machine <br> Provides the vehicle's mechanical power through 4 wheel motors. ",
        },
        powertrain: {
          title: "Powertrain",
          label:
            "Performance ensured by a compact and efficient 600V accumulator <br> Cooling and custom inverter housing integrating several printed circuits designed for monitoring high voltage circuits.",
        },
        dynamics: {
          title: "Dynamics",
          label:
            "Responsive and agile driving thanks to decoupled suspension and DSSV technology. Brake calipers, double wishbone suspension and rocker arms entirely designed by Formule ETS members.",
        },
        electronics: {
          title: "Electronics",
          label:
            "The programmed Vehicle Control Unit (VCU) is shaped by our own expertise. <br> Accumulator's performances are optimized thanks to the Battery Management System (BMS). <br> The vehicle Power Management Unit (PMU) allows car's power monitoring.",
        },
        aerodynamics: {
          title: "Aerodynamics",
          label:
            "Development of an optimized and efficient aerodynamic package <br> to manage airflows around the car. <br> Enhancement of performances by exploiting ground effect and producing <br> downforce to allow faster cornering <br> Double action drag reduction system (DRS).",
        },
        thank: {
          title: "External Relationship & Logistics",
          label:
            "Promotion of the club and relations with partners. <br> Organization of events to ensure the visibility of the team and its sponsors <br> Management of social networks and exchange with the community.",
        },
      },
    },

    "3dmodel": {
      textureLoading: "Loading textures",
      modelLoading: "Loading the model",
    },

    contact: {
      contact: "Contact US",
    },

    donate: {
      particular: {
        button: "Make a donation (private)",
        title: "The gift",
        text: `By clicking on the link above, you will be transferred to the secure site of the ÉTS Development Fund. In order to make a donation as an individual, be sure to check "individual" then complete the form.`,
        italic: "We are very grateful for your help!",
      },

      sponsorship: {
        button: "Sponsorship (company)",
        title: "THE FINANCIAL SPONSORSHIP",
        text: `By clicking on the link above, you will be transferred to the secure site of the ÉTS Development Fund. In order to sponsor the Formule ETS as a company, make sure to check "corporate" then fill out the form. The link below is our sponsorship document outlining the benefits available to you depending on your sponsorship level.`,
        italic: "Looking forward to working with you!",
        link: {
          message: "OFFICIAL SPONSORSHIP DOCUMENT",
          href: "static/pdf/FormuleETS_PartnershipProposal_2026.pdf"
        },
      },
    },
  },
};

export default en;
